import React from "react";
import { CallbackComponent } from "redux-oidc";
import { navigate } from "@reach/router";

class CallbackPage extends React.Component {
  successCallback = () => {
    console.log("Success", `${process.env.PUBLIC_URL}/`);
    navigate(`${process.env.PUBLIC_URL}/`);
  };

  errorCallback = () => {
    console.log("Error", `${process.env.PUBLIC_URL}/`);
    navigate(`${process.env.PUBLIC_URL}/`);
  };

  render() {
    // just redirect to '/' in both cases
    return (
      <CallbackComponent
        userManager={this.props.userManager}
        successCallback={this.successCallback}
        errorCallback={this.errorCallback}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}

export default CallbackPage;
